export default __webpack_public_path__ + "static/media/prithvi.f0d69c5a.jpeg";